"use strict";

var _interopRequireDefault = require("/opt/jenkins/workspace/sit-app-client/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("/opt/jenkins/workspace/sit-app-client/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard"));

var _vue = _interopRequireDefault(require("vue"));

var _vueRouter = _interopRequireDefault(require("vue-router"));

var _zixun = _interopRequireDefault(require("@/view/zixun"));

var originalPush = _vueRouter.default.prototype.push;

_vueRouter.default.prototype.push = function push(to) {
  return originalPush.call(this, to).catch(function (err) {
    return err;
  });
};

_vue.default.use(_vueRouter.default);

var _default = new _vueRouter.default({
  routes: [{
    path: '/',
    redirect: 'zixun'
  }, {
    path: '/zixun',
    name: 'zixun',
    component: _zixun.default
  }, {
    path: '/open-in-browser',
    name: 'OpenInBrowser',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/view/open-in-browser'));
      });
    }
  }, {
    path: '/open-app',
    name: 'OpenApp',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/view/open-app'));
      });
    }
  }, {
    path: '/live',
    name: 'Live',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/view/live'));
      });
    }
  }]
});

exports.default = _default;